export class QuotaExceededError extends Error {
    public name = 'QuotaExceededError';
}
